import React, { FC } from 'react';
import { StatementBox } from 'src/components';
import { ConstraintsTitle } from '../atoms';
import { PortfolioLoanType } from '../../../model';
import { CriteriaRow } from '../..';
import styles from './SMEPurposes.module.scss';

type Props = {
  isViewPage: boolean;
  smePurposes: PortfolioLoanType[];
  onChange: (id: string, value: number) => void;
};

const SMEPurposes: FC<Props> = ({ isViewPage, smePurposes, onChange }) => {
  return (
    <StatementBox className={styles.box}>
      <ConstraintsTitle title="Loan Purposes - SME" />

      <div className={styles.content}>
        {smePurposes?.map(({ id, name, percentage }) => (
          <CriteriaRow
            key={name}
            label={name}
            value={percentage}
            onChange={(value: number) => onChange(id, value)}
            readOnly={isViewPage}
          />
        ))}
      </div>
    </StatementBox>
  );
};

export default SMEPurposes;
